<ng-container *ngIf="events$ | async as event">
  <div *ngIf="isProgressEvent(event)"
       class="loading-bar-progress branding-accent-dark-background branding-accent-dark-foreground"
       [style.width]="event.value + '%'">
  </div>
</ng-container>
